export const statusFillColor = (
  status:
    | 'allocated'
    | 'assigned'
    | 'onboarded'
    | 'unfindabled'
    | 'pending'
    | 'available'
    | 'paused'
    | 'returning'
    | 'onboardFlagged'
): string => {
  switch (status) {
    case 'allocated':
      return '#1c64f2' // blue-600
    case 'onboarded':
      return '#0e9f6e' // green-500
    case 'unfindabled':
      return '#ff8a4c' // orange-400
    case 'pending':
      return '#f3f4f6' // gray-100
    case 'onboardFlagged':
      return '#B9E6D6'
    default:
      return 'white'
  }
}

export const statusStrokeColor = (
  status:
    | 'allocated'
    | 'assigned'
    | 'onboarded'
    | 'unfindabled'
    | 'pending'
    | 'available'
    | 'paused'
    | 'returning'
    | 'onboardFlagged'
): string => {
  switch (status) {
    case 'allocated':
      return '#233876' // blue-900
    case 'assigned':
      return '#1c64f2' // blue-600
    case 'onboarded':
      return '#014737' // green-900
    case 'unfindabled':
      return '#8a2c0d' // orange-800
    case 'available':
      return '#1f2a37' // gray-800
    case 'pending':
      return '#6b7280' // gray-500
    case 'paused':
    case 'returning':
      return '#d03801' // orange-600
    case 'onboardFlagged':
      return '#5A8B84'
    default:
      return 'black'
  }
}

export const statusTextColor = (
  status:
    | 'allocated'
    | 'assigned'
    | 'onboarded'
    | 'unfindabled'
    | 'pending'
    | 'available'
    | 'paused'
    | 'returning'
    | 'onboardFlagged'
): string => {
  switch (status) {
    case 'allocated':
    case 'onboarded':
      return 'white'
    case 'onboardFlagged':
      return '#0E9F6E'
    default:
      return statusStrokeColor(status)
  }
}
